// extracted by mini-css-extract-plugin
module.exports = {"container":"TaxIncomeSectionShow__container--_Jp0G"};